import { useQuery } from "react-query";
import { getDataWithoutParams } from "../api";

export const useGetDataWithoutParams = (key, api, enabled = true) => {
  return useQuery([key], () => getDataWithoutParams(api), { enabled: enabled });
};
